import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import React, { useEffect } from "react";
import VerBusinessDetails from "../../../components/common/VerBusinessDetails";
import { useParams } from "react-router-dom";
import { getRegisteredAddress } from "../redux/action/getRegisteredAddress";

const VerRegisteredAddress: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { appId } = useParams();
  const customerId = Number(appId);
  useEffect(() => {
    dispatch(getRegisteredAddress(customerId));
  }, [customerId, dispatch]);
  const state = useSelector(
    (state: RootState) => state.verification.verRegAddressDetails
  );

  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp
  );

  if (!state.data || !state.data.data) {
    return <Row>Loading....</Row>;
  }
  const regAddressDetailsStore = state.data.data.result.result[0];
  const shippingAddrId = getAppSelector.data.business_shipping_address_type_id;
  const billingAddrId = getAppSelector.data.business_billing_address_type_id;
  const isIndia =
    getAppSelector.data.business_registration_country_id ===
    Number(process.env.REACT_APP_COUNTRY_ID);
  const regAddrId = regAddressDetailsStore && regAddressDetailsStore.id;
  const isCP = getAppSelector.data.is_counterparty;
  const handleNullValue = (value: null, defaultValue: any) => {
    return value != null ? value : defaultValue;
  };

  return (
    <>
      {/* <Row md={12}>
        <Col md={12}>
          <VerBusinessDetails label="Address Type" defaultValue="Registered" />
        </Col>
      </Row> */}
      {regAddressDetailsStore && (
        <>
          <Row md={12}>
            <Col md={12}>
              <VerBusinessDetails
                label="Address Line 1"
                defaultValue={regAddressDetailsStore?.line_1}
                colored={regAddressDetailsStore.api_line_1_flag}
                required
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col md={12}>
              <VerBusinessDetails
                label="Address Line 2"
                defaultValue={regAddressDetailsStore?.line_2}
                colored={regAddressDetailsStore.api_line_2_flag}
                required
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col md={6}>
              <VerBusinessDetails
                label="City"
                defaultValue={regAddressDetailsStore?.city}
                colored={regAddressDetailsStore.api_city_flag}
                required
              />
            </Col>
            <Col md={6}>
              <VerBusinessDetails
                label="District"
                defaultValue={regAddressDetailsStore?.district}
                colored={regAddressDetailsStore.api_district_flag}
                required
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col md={6}>
              <VerBusinessDetails
                label="State/ County"
                defaultValue={regAddressDetailsStore?.state}
                colored={regAddressDetailsStore.api_state_flag}
                required
              />
            </Col>
            <Col md={6}>
              <VerBusinessDetails
                label="Country"
                defaultValue={regAddressDetailsStore?.country_id.name}
                colored={regAddressDetailsStore.api_country_flag}
                required
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col md={12}>
              <VerBusinessDetails
                label="Email"
                defaultValue={regAddressDetailsStore?.email}
                required
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col md={6}>
              <VerBusinessDetails
                label="PIN/ ZIP Code"
                defaultValue={regAddressDetailsStore?.pincode}
                colored={regAddressDetailsStore.postal_pincode_api_success}
                required
              />
            </Col>
            <Col md={6}>
              <VerBusinessDetails
                label="Cellphone"
                defaultValue={
                  regAddressDetailsStore?.phone_country_code +
                  -+regAddressDetailsStore?.phone
                }
                required
              />
            </Col>
          </Row>
          {isIndia && (
            <Row md={12}>
              <Col md={12}>
                <VerBusinessDetails
                  label="Billing GSTIN"
                  defaultValue={regAddressDetailsStore?.business_billing_gstn}
                />
              </Col>
            </Row>
          )}
          {!isCP && (
            <>
              <Row md={12}>
                <Col md={12}>
                  <VerBusinessDetails
                    label="Billing Preference"
                    defaultValue={
                      regAddressDetailsStore?.business_billing_preference_email
                    }
                    required
                  />
                </Col>
              </Row>

              <Row md={12}>
                <Col md={12}>
                  <VerBusinessDetails
                    label="Communication Preference"
                    defaultValue={
                      regAddressDetailsStore?.business_communication_preference_email
                    }
                    required
                  />
                </Col>
              </Row>
            </>
          )}

          <Row md={12}>
            <Col md={6}>
              <VerBusinessDetails
                label="Is Shipping Address"
                defaultValue={regAddrId === shippingAddrId ? "Yes" : "No"}
              />
            </Col>
            <Col md={6}>
              <VerBusinessDetails
                label="Is Billing Address"
                defaultValue={regAddrId === billingAddrId ? "Yes" : "No"}
              />
            </Col>
          </Row>
        </>
      )}

      {/* <Row md={12}>
        <Col md={12}>
          <VerBusinessDetails
            label="Billing GSTIN"
            defaultValue={regAddressDetailsStore.billing_gstn}
          />
        </Col>
      </Row> */}
    </>
  );
};

export default VerRegisteredAddress;
